(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-3d-carousel-spring", [], factory);
	else if(typeof exports === 'object')
		exports["react-3d-carousel-spring"] = factory();
	else
		root["react-3d-carousel-spring"] = factory();
})(self, function() {
return 